/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Membership page member counts and member list callable wrappers (F032 step 8c).
 */

import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "../store/firebaseApp";
import type {
  GetMembershipStatsRequest,
  GetMembershipStatsResponse,
  GetMembershipMembersRequest,
  GetMembershipMembersResponse,
} from "@lemonadetraining/contracts";

// async so a synchronous throw inside httpsCallable still reaches the caller's .catch.
export const getMembershipStats = async (
  data: GetMembershipStatsRequest
): Promise<GetMembershipStatsResponse> => {
  const fn = httpsCallable<GetMembershipStatsRequest, GetMembershipStatsResponse>(
    firebaseFunctions,
    "getMembershipStats"
  );
  return (await fn(data)).data;
};

export const getMembershipMembers = async (
  data: GetMembershipMembersRequest
): Promise<GetMembershipMembersResponse> => {
  const fn = httpsCallable<GetMembershipMembersRequest, GetMembershipMembersResponse>(
    firebaseFunctions,
    "getMembershipMembers"
  );
  return (await fn(data)).data;
};
